import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;   /* fallback for browsers without dvh support */
  height: 100dvh;  /* dynamic viewport height - adjusts as iOS Safari address bar shows/hides */
  display: flex;
  overflow: hidden;

  ${({ theme }) => css`
    background-color: ${theme.colors?.background || '#0D0D16'};
  `}
`;

export const FormSide = styled.div`
  width: 420px;
  min-width: 360px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${({ theme }) => css`
    padding: ${theme.spacing?.level7 || '32px'} ${theme.spacing?.level7 || '32px'};
  `}

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }

  @media (max-width: 480px) {
    ${({ theme }) => css`
      padding: ${theme.spacing?.level6 || '24px'} ${theme.spacing?.level5 || '16px'};
    `}
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 48px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurface || '#ffffff'};
    font-family: ${theme.font?.fontFamily || "'Inter Variable', 'Inter', sans-serif"};
  `}
`;

export const LogoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 800;
  color: white;

  ${({ theme }) => css`
    background: linear-gradient(
      135deg,
      ${theme.colors?.primaryContainer || '#413ED0'} 0%,
      ${theme.colors?.primary || '#C1C1FF'} 100%
    );
  `}
`;

export const FormContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 340px;
  width: 100%;

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

export const BackgroundSide = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SpiralPattern = styled.div`
  position: absolute;
  inset: 0;

  ${({ theme }) => {
    const primary = theme.colors?.primaryContainer || '#413ED0';
    return css`
      background: radial-gradient(
        ellipse at center,
        ${primary}14 0%,
        transparent 70%
      );

      &::before {
        content: '';
        position: absolute;
        inset: -50%;
        background: conic-gradient(
          from 0deg at 50% 50%,
          transparent 0deg,
          ${primary}08 30deg,
          transparent 60deg,
          ${primary}06 90deg,
          transparent 120deg,
          ${primary}08 150deg,
          transparent 180deg,
          ${primary}06 210deg,
          transparent 240deg,
          ${primary}08 270deg,
          transparent 300deg,
          ${primary}06 330deg,
          transparent 360deg
        );
        animation: rotate 120s linear infinite;
      }

      &::after {
        content: '';
        position: absolute;
        inset: -30%;
        background: conic-gradient(
          from 180deg at 50% 50%,
          transparent 0deg,
          ${primary}0A 45deg,
          transparent 90deg,
          ${primary}08 135deg,
          transparent 180deg,
          ${primary}0A 225deg,
          transparent 270deg,
          ${primary}08 315deg,
          transparent 360deg
        );
        animation: rotate 80s linear infinite reverse;
      }

      @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
  }}
`;
